const RING_RADIUS = 12;

/**
 * Content-space top of each margin ring. The first painted mark or cell for
 * an id wins, so a wrapped highlight keeps one ring beside its first line.
 */
export function marginRingOffsets(
  root: HTMLElement,
  scroll: HTMLElement,
): { id: string; y: number }[] {
  const scrollRect = scroll.getBoundingClientRect();
  const seen = new Set<string>();
  const positions: { id: string; y: number }[] = [];
  for (const node of root.querySelectorAll<HTMLElement>('mark[data-hl-id], td[data-hl-id]')) {
    const id = node.dataset.hlId;
    if (!id || seen.has(id)) continue;
    seen.add(id);
    const rect = node.getBoundingClientRect();
    const center = rect.top - scrollRect.top + scroll.scrollTop + rect.height / 2;
    positions.push({ id, y: center - RING_RADIUS });
  }
  return positions;
}

/** The element that actually scrolls text, Word, and spreadsheet previews. */
export function markingScrollHost(scroll: HTMLElement): HTMLElement {
  return scroll.querySelector<HTMLElement>('.fp-text-view, .fp-docx, .fp-sheet') ?? scroll;
}
